<div class="user_filter">
    <div class="display-options-left">
        <div class="segmented-control">
            <button class="segment" [class.active]="isApplicationUsage" (click)="setAppWise()"
                [disabled]="timesheetMode === 'period'"
                [matTooltip]="timesheetMode === 'period' ? 'Not available in Period-wise mode' : ''">
                By App
            </button>
            <button class="segment" [class.active]="isWebsiteUsage" (click)="setWebsiteWise()"
                [disabled]="timesheetMode === 'period'"
                [matTooltip]="timesheetMode === 'period' ? 'Not available in Period-wise mode' : ''">
                By Website
                <span class="beta-tag" *ngIf="sysConfig.isBeta" [matTooltip]="sysConfig.betaTooltip">Beta</span>
            </button>
        </div>
    </div>

    <div class="display-options-right">
        <button mat-stroked-button class="employee-add-btn secondary-btn icon-only-export"
            (click)="exportData()" matTooltip="Export" aria-label="Export">
            <mat-icon class="export-icon" aria-hidden="true">file_download</mat-icon>
            <span class="export-btn-label">Export</span>
        </button>
    </div>
</div>